import template from './template.html';
import './styles.css';


controller.$inject = ['$state', 'DateService', '$rootScope'];

export function controller($state, DateService, $rootScope) {
    let vm = {};
    this.$onInit = function() {
    vm = this;

    vm.date = DateService.getSundayForDate(vm.date);
    vm.jsdate = DateService.convertToJSPLCDate(vm.date);
    vm.endDate = addDays(vm.date, 6);
    vm.goForward = () => updateDate(7);
    vm.goBack = () => updateDate(-7);
    }
    function updateDateInDriverViewState(date) {
        // I've not coded in Angular in 9 months, never in 1.5 and never used stateProvider. I've got to rush out a fix for this. I'm sure there is a better way to do this. Sorry.
        // This is a bit of a hack that forces it to stay in the drive.planner state. Otherwise it jumps back to week view (DRM-1239)
        vm.date = date;
        $rootScope.$broadcast('date-changed-in-driver-view', date);
        var newState = $state.params;
        newState.week = date.toUTCString();
        $state.go('planner.driver', $state.params, { reload: 'planner.driver' });

        vm.endDate = addDays(vm.date, 6);
        vm.jsdate = DateService.convertToJSPLCDate(vm.date);
    }

    function updateDateInScheduleState(date) {
        $state.go('planner.schedule', {
            week: date.toUTCString()
        }, {
            reload: true
        });
    }

    function updateDate(days) {
        const date = addDays(vm.date, days);
        if ($state.current.name === 'planner.driver') {
            updateDateInDriverViewState(date);
        } else {
            updateDateInScheduleState(date);
        }
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setHours(12);
        result.setDate(result.getDate() + days);
        return result;
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        date: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/weekselector/index.js